import { Platform } from "react-native";

export function loadImage(file) {
	return new Promise((resolve, reject) => {
		if (!isWeb()) return resolve(file.uri);
		const reader = new FileReader();
		if (file) {
			reader.readAsDataURL(file);
		}
		reader.onload = function () {
			resolve(reader.result);
		};
		reader.onerror = function (error) {
			reject(error);
		};
	});
}

function isWeb() {
	return Platform.OS === "web";
}